import React, { useMemo, useState } from "react";
import { FilterCells, Paragraph, useColorTokens } from "@tvg/design-system";
import { useSelector } from "react-redux";
import { replaceCAPIVariables } from "@tvg/utils/capiWtxMessagesUtils";
import { Container, Header, PPWrapper } from "./styled-components";
import { FiltersInlinePP, Props } from "./types";
import PastRace from "../PastRace";
import { getInlinePPContent } from "../../../../store/selectors";
import { buildFitlerOptions, getFilteredRaces } from "./functions";

const InlinePastPerformances = ({
  onSelectRace,
  races,
  currentRace,
  currentRaceDistance,
  currentRaceSurface,
  isMobile = false
}: Props) => {
  const colorTokens = useColorTokens();
  const [activeFilter, setActiveFilter] = useState(FiltersInlinePP.RECENT);
  const { maxResults, emptyMessages } = useSelector(getInlinePPContent);

  const filteredRaces = useMemo(
    () => getFilteredRaces(activeFilter, currentRace, races, maxResults),
    [activeFilter, currentRace, races, maxResults]
  );

  return (
    <Container isEmpty={races.length === 0}>
      {races.length === 0 ? (
        <Paragraph
          qaLabel="runner-handicap-inline-pp-all-filters-empty"
          color={colorTokens.content.subtle}
        >
          {emptyMessages.recentRaces}
        </Paragraph>
      ) : (
        <>
          {!isMobile && (
            <Header>
              <FilterCells
                filterOptions={buildFitlerOptions(currentRace.track?.shortName)}
                size="s"
                activeValue={activeFilter}
                onChange={(value) => setActiveFilter(value as FiltersInlinePP)}
                hasShadow={true}
              />
              <Paragraph
                qaLabel="runner-handicap-inline-pos-header"
                fontSize="xs"
                fontFamily="condensedRegular"
                color={colorTokens.content.subtle}
              >
                POS.
              </Paragraph>
              <Paragraph
                qaLabel="runner-handicap-inline-odd-header"
                fontSize="xs"
                fontFamily="condensedRegular"
                color={colorTokens.content.subtle}
                textAlign="right"
              >
                ODDS
              </Paragraph>
            </Header>
          )}
          {filteredRaces.length === 0 ? (
            <Paragraph qaLabel="runner-handicap-inline-filter-empty">
              {replaceCAPIVariables(emptyMessages.filteredRaces, {
                trackName: currentRace.track?.trackName as string
              })}
            </Paragraph>
          ) : (
            filteredRaces
              .slice(0, isMobile ? 3 : undefined)
              .map((race, index) => (
                <PPWrapper
                  key={race.id + index.toString()}
                  onClick={() => onSelectRace(index)}
                  data-qa-label="runner-handicap-inline-race-select"
                  role="button"
                >
                  <PastRace
                    key={race.id + index.toString()}
                    race={race}
                    currentRaceDistance={currentRaceDistance}
                    currentRaceSurface={currentRaceSurface}
                    isMobile={isMobile}
                  />
                </PPWrapper>
              ))
          )}
        </>
      )}
    </Container>
  );
};

export default InlinePastPerformances;
